<div class="channel-actions-dashboard">
  <!-- Header -->
  <div class="dashboard-header">
    <div class="header-left">
      <h1><i class="fa-solid fa-bolt"></i> Channel Actions</h1>
      <span class="subtitle" *ngIf="selectedChannel">{{ selectedChannel.Name }}</span>
    </div>
    <div class="header-right">
      <!-- Organization Selector -->
      <div class="org-selector" *ngIf="organizations.length > 1">
        <label>Organization:</label>
        <select
          [ngModel]="selectedOrganization?.ID"
          (ngModelChange)="onOrganizationChange($event)"
        >
          <option *ngFor="let org of organizations" [value]="org.ID">{{ org.Name }}</option>
        </select>
      </div>
      <!-- Channel Selector -->
      <div class="channel-selector" *ngIf="filteredChannels.length > 0">
        <label>Channel:</label>
        <select
          [ngModel]="selectedChannel?.ID"
          (ngModelChange)="onChannelChange($event)"
        >
          <option *ngFor="let channel of filteredChannels" [value]="channel.ID">{{ channel.Name }}</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoading">
    <i class="fa-solid fa-spinner fa-spin"></i>
    <span>Loading channel actions...</span>
  </div>

  <!-- Error Message -->
  <div class="error-banner" *ngIf="errorMessage">
    <i class="fa-solid fa-exclamation-triangle"></i>
    {{ errorMessage }}
    <button class="close-btn" (click)="errorMessage = ''">
      <i class="fa-solid fa-times"></i>
    </button>
  </div>

  <!-- Success Message -->
  <div class="success-banner" *ngIf="successMessage">
    <i class="fa-solid fa-check-circle"></i>
    {{ successMessage }}
  </div>

  <!-- Main Content -->
  <div class="dashboard-content" *ngIf="!isLoading && selectedChannel">
    <!-- Inheritance Info Banner -->
    <div class="inheritance-banner" *ngIf="inheritedFromOrg.length > 0 || inheritedFromChannelType.length > 0">
      <i class="fa-solid fa-sitemap"></i>
      <span>
        This channel inherits actions from:
        <strong *ngIf="inheritedFromOrg.length > 0">Organization ({{ inheritedFromOrg.length }})</strong>
        <span *ngIf="inheritedFromOrg.length > 0 && inheritedFromChannelType.length > 0"> and </span>
        <strong *ngIf="inheritedFromChannelType.length > 0">Channel Type ({{ inheritedFromChannelType.length }})</strong>
      </span>
      <button class="btn-link" (click)="toggleInheritedActions()">
        {{ showInheritedActions ? 'Hide Inherited' : 'Show Inherited' }}
      </button>
    </div>

    <!-- Toolbar -->
    <div class="toolbar">
      <div class="toolbar-left">
        <button class="btn btn-primary" (click)="startCreate()" [disabled]="isCreating || isSaving">
          <i class="fa-solid fa-plus"></i> Add Action
        </button>
      </div>
      <div class="toolbar-right">
        <div class="filter-group">
          <label>Status:</label>
          <select [(ngModel)]="statusFilter">
            <option *ngFor="let status of statusOptions" [value]="status">{{ status }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Create Form -->
    <div class="action-card create-card" *ngIf="isCreating">
      <div class="card-header">
        <h3><i class="fa-solid fa-plus-circle"></i> New Channel Action</h3>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="form-group">
            <label>Action *</label>
            <select [(ngModel)]="createForm.actionId" required>
              <option value="">-- Select Action --</option>
              <option *ngFor="let action of availableActions" [value]="action.ID">{{ action.Name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Status</label>
            <select [(ngModel)]="createForm.status">
              <option value="Active">Active</option>
              <option value="Pending">Pending</option>
              <option value="Revoked">Revoked</option>
            </select>
          </div>
          <div class="form-group">
            <label>Sequence</label>
            <input type="number" [(ngModel)]="createForm.sequence" min="0" />
          </div>
        </div>

        <div class="form-section">
          <h4><i class="fa-solid fa-key"></i> Credentials (Encrypted on Server)</h4>
          <div class="form-row">
            <div class="form-group">
              <label>API Key</label>
              <input type="password" [(ngModel)]="createForm.credentials.apiKey" placeholder="Enter API key" />
            </div>
            <div class="form-group">
              <label>Username</label>
              <input type="text" [(ngModel)]="createForm.credentials.username" placeholder="Username" />
            </div>
            <div class="form-group">
              <label>Password</label>
              <input type="password" [(ngModel)]="createForm.credentials.password" placeholder="Password" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Client ID</label>
              <input type="text" [(ngModel)]="createForm.credentials.clientId" placeholder="OAuth Client ID" />
            </div>
            <div class="form-group">
              <label>Client Secret</label>
              <input type="password" [(ngModel)]="createForm.credentials.clientSecret" placeholder="OAuth Client Secret" />
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Credential Notes</label>
          <textarea [(ngModel)]="createForm.credentialNotes" rows="2" placeholder="Notes about these credentials"></textarea>
        </div>

        <!-- Agent Scope Section -->
        <div class="form-section agent-scope-section">
          <h4><i class="fa-solid fa-users-cog"></i> Agent Scope</h4>
          <p class="section-description">Control which parts of Izzy can use this action</p>

          <div class="scope-toggle">
            <label class="toggle-option" [class.selected]="createForm.agentScopeMode === 'global'">
              <input type="radio" [(ngModel)]="createForm.agentScopeMode" value="global" name="createAgentScope" />
              <i class="fa-solid fa-globe"></i>
              <span class="toggle-label">All Agents</span>
              <span class="toggle-description">Available to all parts of Izzy</span>
            </label>
            <label class="toggle-option" [class.selected]="createForm.agentScopeMode === 'specific'">
              <input type="radio" [(ngModel)]="createForm.agentScopeMode" value="specific" name="createAgentScope" />
              <i class="fa-solid fa-crosshairs"></i>
              <span class="toggle-label">Specific Agents</span>
              <span class="toggle-description">Choose which agents can use this action</span>
            </label>
          </div>

          <div class="agent-selection" *ngIf="createForm.agentScopeMode === 'specific'">
            <div class="agent-chips">
              <label
                *ngFor="let agent of availableSubAgents"
                class="agent-chip"
                [class.selected]="isAgentSelected(createForm, agent.id)"
              >
                <input
                  type="checkbox"
                  [checked]="isAgentSelected(createForm, agent.id)"
                  (change)="toggleAgentSelection(createForm, agent.id)"
                />
                <i [class]="agent.iconClass"></i>
                <span>{{ agent.displayName }}</span>
              </label>
            </div>
            <p class="help-text" *ngIf="createForm.selectedAgentIds.length === 0">
              <i class="fa-solid fa-info-circle"></i> Select at least one agent
            </p>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button class="btn btn-secondary" (click)="cancelCreate()" [disabled]="isSaving">Cancel</button>
        <button class="btn btn-primary" (click)="saveCreate()" [disabled]="isSaving || !createForm.actionId || (createForm.agentScopeMode === 'specific' && createForm.selectedAgentIds.length === 0)">
          <i class="fa-solid fa-save" *ngIf="!isSaving"></i>
          <i class="fa-solid fa-spinner fa-spin" *ngIf="isSaving"></i>
          Save
        </button>
      </div>
    </div>

    <!-- Unified Actions List (with inheritance) -->
    <div class="actions-list" *ngIf="showInheritedActions && (inheritedFromOrg.length > 0 || inheritedFromChannelType.length > 0)">
      <h3 class="section-title">
        <i class="fa-solid fa-layer-group"></i> All Actions (including inherited)
      </h3>

      <div class="empty-state" *ngIf="displayedUnifiedActions.length === 0 && !isCreating">
        <i class="fa-solid fa-bolt-slash"></i>
        <p>No actions configured for this channel</p>
        <button class="btn btn-primary" (click)="startCreate()">
          <i class="fa-solid fa-plus"></i> Add First Action
        </button>
      </div>

      <div
        class="action-card"
        *ngFor="let unified of displayedUnifiedActions; let i = index"
        [class.inherited]="unified.source !== 'channel'"
        [class.is-channel]="unified.source === 'channel'"
      >
        <div class="card-header">
          <div class="action-info">
            <span class="sequence-badge">#{{ unified.sequence }}</span>
            <h3>{{ unified.actionName }}</h3>
            <span class="status-badge" [ngClass]="getStatusClass(unified.status)">
              {{ unified.status }}
            </span>
            <span class="source-badge" [ngClass]="getSourceClass(unified.source)">
              <i class="fa-solid" [ngClass]="{
                'fa-broadcast-tower': unified.source === 'channel',
                'fa-layer-group': unified.source === 'channelType',
                'fa-building': unified.source === 'organization'
              }"></i>
              {{ getSourceLabel(unified.source) }}
            </span>
          </div>
          <div class="action-buttons">
            <!-- Channel-level actions can be edited -->
            <ng-container *ngIf="unified.canEdit">
              <button class="btn-icon" (click)="moveUp(channelActions[i])" [disabled]="i === 0 || isSaving" title="Move Up">
                <i class="fa-solid fa-arrow-up"></i>
              </button>
              <button class="btn-icon" (click)="moveDown(channelActions[i])" [disabled]="i === channelActions.length - 1 || isSaving" title="Move Down">
                <i class="fa-solid fa-arrow-down"></i>
              </button>
              <button class="btn-icon" (click)="startEdit(channelActions[i])" [disabled]="isSaving" title="Edit">
                <i class="fa-solid fa-edit"></i>
              </button>
              <button class="btn-icon btn-danger" (click)="confirmDelete(channelActions[i])" [disabled]="isSaving" title="Delete">
                <i class="fa-solid fa-trash"></i>
              </button>
            </ng-container>
            <!-- Inherited actions can be copied to channel -->
            <ng-container *ngIf="!unified.canEdit">
              <button class="btn btn-sm btn-secondary" (click)="copyToChannel(unified)" [disabled]="isSaving" title="Override at channel level">
                <i class="fa-solid fa-copy"></i> Override
              </button>
            </ng-container>
          </div>
        </div>
        <div class="card-body" *ngIf="unified.credentialNotes || unified.configuration || unified.hasCredentials">
          <div class="detail-row" *ngIf="unified.credentialNotes">
            <label>Credential Notes:</label>
            <span>{{ unified.credentialNotes }}</span>
          </div>
          <div class="detail-row" *ngIf="unified.configuration">
            <label>Configuration:</label>
            <code>{{ unified.configuration }}</code>
          </div>
          <div class="detail-row" *ngIf="unified.hasCredentials">
            <label>Credentials:</label>
            <span class="encrypted-indicator">
              <i class="fa-solid fa-lock"></i> Encrypted
              <span class="cred-source" *ngIf="unified.source !== 'channel'">(from {{ getSourceLabel(unified.source) }})</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Channel-Only Actions List (original, when not showing inherited) -->
    <div class="actions-list" *ngIf="!showInheritedActions || (inheritedFromOrg.length === 0 && inheritedFromChannelType.length === 0)">
      <div class="empty-state" *ngIf="filteredActions.length === 0 && !isCreating">
        <i class="fa-solid fa-bolt-slash"></i>
        <p>No actions configured for this channel</p>
        <button class="btn btn-primary" (click)="startCreate()">
          <i class="fa-solid fa-plus"></i> Add First Action
        </button>
      </div>

      <div
        class="action-card"
        *ngFor="let display of filteredActions; let i = index"
        [class.is-editing]="display.isEditing"
      >
        <!-- View Mode -->
        <ng-container *ngIf="!display.isEditing">
          <div class="card-header">
            <div class="action-info">
              <span class="sequence-badge">#{{ display.action.Sequence }}</span>
              <h3>{{ getActionName(display.action.ActionID) }}</h3>
              <span class="status-badge" [ngClass]="getStatusClass(display.action.Status)">
                {{ display.action.Status }}
              </span>
              <span class="source-badge source-channel">
                <i class="fa-solid fa-broadcast-tower"></i> Channel
              </span>
            </div>
            <div class="action-buttons">
              <button class="btn-icon" (click)="moveUp(display)" [disabled]="i === 0 || isSaving" title="Move Up">
                <i class="fa-solid fa-arrow-up"></i>
              </button>
              <button class="btn-icon" (click)="moveDown(display)" [disabled]="i === filteredActions.length - 1 || isSaving" title="Move Down">
                <i class="fa-solid fa-arrow-down"></i>
              </button>
              <button class="btn-icon" (click)="startEdit(display)" [disabled]="isSaving" title="Edit">
                <i class="fa-solid fa-edit"></i>
              </button>
              <button class="btn-icon btn-danger" (click)="confirmDelete(display)" [disabled]="isSaving" title="Delete">
                <i class="fa-solid fa-trash"></i>
              </button>
              <button class="btn-icon" (click)="openActionRecord(display)" title="Open Record">
                <i class="fa-solid fa-external-link-alt"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="detail-row agent-scope-display">
              <label><i class="fa-solid fa-users-cog"></i> Agent Scope:</label>
              <span class="scope-badge" [class.scope-global]="!display.action.Configuration || getAgentScopeDisplayText(display.action.Configuration) === 'All Agents'" [class.scope-specific]="display.action.Configuration && getAgentScopeDisplayText(display.action.Configuration) !== 'All Agents'">
                {{ getAgentScopeDisplayText(display.action.Configuration) }}
              </span>
            </div>
            <div class="detail-row" *ngIf="display.action.CredentialNotes">
              <label>Credential Notes:</label>
              <span>{{ display.action.CredentialNotes }}</span>
            </div>
            <div class="detail-row" *ngIf="display.action.EncryptedCredentials">
              <label>Credentials:</label>
              <span class="encrypted-indicator"><i class="fa-solid fa-lock"></i> Encrypted</span>
            </div>
          </div>
        </ng-container>

        <!-- Edit Mode -->
        <ng-container *ngIf="display.isEditing">
          <div class="card-header">
            <h3><i class="fa-solid fa-edit"></i> Edit Channel Action</h3>
          </div>
          <div class="card-body">
            <div class="form-row">
              <div class="form-group">
                <label>Action</label>
                <select [(ngModel)]="display.editForm.actionId">
                  <option *ngFor="let action of availableActions" [value]="action.ID">{{ action.Name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>Status</label>
                <select [(ngModel)]="display.editForm.status">
                  <option value="Active">Active</option>
                  <option value="Pending">Pending</option>
                  <option value="Revoked">Revoked</option>
                </select>
              </div>
              <div class="form-group">
                <label>Sequence</label>
                <input type="number" [(ngModel)]="display.editForm.sequence" min="0" />
              </div>
            </div>

            <div class="form-section">
              <h4><i class="fa-solid fa-key"></i> Update Credentials (leave blank to keep existing)</h4>
              <div class="form-row">
                <div class="form-group">
                  <label>API Key</label>
                  <input type="password" [(ngModel)]="display.editForm.credentials.apiKey" placeholder="Enter new API key" />
                </div>
                <div class="form-group">
                  <label>Username</label>
                  <input type="text" [(ngModel)]="display.editForm.credentials.username" placeholder="Username" />
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <input type="password" [(ngModel)]="display.editForm.credentials.password" placeholder="Password" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label>Client ID</label>
                  <input type="text" [(ngModel)]="display.editForm.credentials.clientId" placeholder="OAuth Client ID" />
                </div>
                <div class="form-group">
                  <label>Client Secret</label>
                  <input type="password" [(ngModel)]="display.editForm.credentials.clientSecret" placeholder="OAuth Client Secret" />
                </div>
              </div>
            </div>

            <div class="form-group">
              <label>Credential Notes</label>
              <textarea [(ngModel)]="display.editForm.credentialNotes" rows="2"></textarea>
            </div>

            <!-- Agent Scope Section -->
            <div class="form-section agent-scope-section">
              <h4><i class="fa-solid fa-users-cog"></i> Agent Scope</h4>
              <p class="section-description">Control which parts of Izzy can use this action</p>

              <div class="scope-toggle">
                <label class="toggle-option" [class.selected]="display.editForm.agentScopeMode === 'global'">
                  <input type="radio" [(ngModel)]="display.editForm.agentScopeMode" value="global" [name]="'editAgentScope_' + display.action.ID" />
                  <i class="fa-solid fa-globe"></i>
                  <span class="toggle-label">All Agents</span>
                  <span class="toggle-description">Available to all parts of Izzy</span>
                </label>
                <label class="toggle-option" [class.selected]="display.editForm.agentScopeMode === 'specific'">
                  <input type="radio" [(ngModel)]="display.editForm.agentScopeMode" value="specific" [name]="'editAgentScope_' + display.action.ID" />
                  <i class="fa-solid fa-crosshairs"></i>
                  <span class="toggle-label">Specific Agents</span>
                  <span class="toggle-description">Choose which agents can use this action</span>
                </label>
              </div>

              <div class="agent-selection" *ngIf="display.editForm.agentScopeMode === 'specific'">
                <div class="agent-chips">
                  <label
                    *ngFor="let agent of availableSubAgents"
                    class="agent-chip"
                    [class.selected]="isAgentSelected(display.editForm, agent.id)"
                  >
                    <input
                      type="checkbox"
                      [checked]="isAgentSelected(display.editForm, agent.id)"
                      (change)="toggleAgentSelection(display.editForm, agent.id)"
                    />
                    <i [class]="agent.iconClass"></i>
                    <span>{{ agent.displayName }}</span>
                  </label>
                </div>
                <p class="help-text" *ngIf="display.editForm.selectedAgentIds.length === 0">
                  <i class="fa-solid fa-info-circle"></i> Select at least one agent
                </p>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <button class="btn btn-secondary" (click)="cancelEdit(display)" [disabled]="isSaving">Cancel</button>
            <button class="btn btn-primary" (click)="saveEdit(display)" [disabled]="isSaving || (display.editForm.agentScopeMode === 'specific' && display.editForm.selectedAgentIds.length === 0)">
              <i class="fa-solid fa-save" *ngIf="!isSaving"></i>
              <i class="fa-solid fa-spinner fa-spin" *ngIf="isSaving"></i>
              Save Changes
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- No Channel Selected -->
  <div class="empty-state" *ngIf="!isLoading && !selectedChannel">
    <i class="fa-solid fa-satellite-dish"></i>
    <p>Select a channel to manage its actions</p>
  </div>

  <!-- Confirm Dialog -->
  <div class="confirm-overlay" *ngIf="confirmDialogVisible" (click)="closeConfirmDialog()">
    <div class="confirm-dialog" (click)="$event.stopPropagation()">
      <h3>{{ confirmDialogTitle }}</h3>
      <p>{{ confirmDialogMessage }}</p>
      <div class="dialog-buttons">
        <button class="btn btn-secondary" (click)="closeConfirmDialog()">Cancel</button>
        <button class="btn btn-danger" (click)="confirmDialogYes()">Delete</button>
      </div>
    </div>
  </div>
</div>
